const isLimeSource = (type: string) => type === "CaOSource";
const isMgOSource  = (type: string) => type === "MgOOnlySource";
const isDolomaSource = (type: string) => type === "DolomaSource";

export {isLimeSource, isMgOSource, isDolomaSource};